import { request } from '@umijs/max';

export const PAYMENT_VOUCHER_PATH = '/purchase-order-management/payment-vouchers';
export const PAYMENT_VOUCHER_PERMISSION = 'purchase:order_payment_voucher_view';

export type PaymentVoucherTodo = { scope: 'self' | 'team' | 'all'; count: number | null };

export function getPaymentVoucherTodo(
  params: {
    recordKind?: 'purchase' | 'logistics';
    keyword?: string;
    paymentChannel?: string;
    startDate?: string;
    endDate?: string;
  } = {},
) {
  return request<PaymentVoucherTodo>('/api/purchase-orders/payment-voucher-center/download-todo', {
    params: {
      keyword: params.keyword,
      ...(params.recordKind ? { record_kind: params.recordKind } : {}),
      payment_channel: params.paymentChannel,
      start_date: params.startDate,
      end_date: params.endDate,
    },
    skipErrorHandler: true,
  });
}
